import {BaseRootEntityService} from '../../base';

export default class HitFormService extends BaseRootEntityService {
  constructor() {
    super('form');
  }
}
